import { begin, end } from 'src/actions/indicator';
import { reducerWithInitialState } from 'typescript-fsa-reducers';

/**
 * Indicatorの制御用キーリスト
 */
export interface IIndicatorState {
	keys: { [K in string]: boolean };
}

const initial: IIndicatorState = {
	keys: {},
};

export default reducerWithInitialState(initial)
	// begin: 対象のキーをtrueに設定
	.case(begin, ({ keys }, payload) => ({
		keys: { ...keys, [payload.key]: true },
	}))
	// end: 対象のキーを削除(引数でdestructuring)
	.case(end, ({ keys: { [payload.key]: {} = {}, ...rest } }, payload) => ({
		keys: rest,
	}));



// WEBPACK FOOTER //
// ./src/reducers/indicator.ts